import React from 'react';

interface FormSectionProps {
  number: number;
  title: string;
  description?: string;
  children: React.ReactNode;
  infoBox?: React.ReactNode;
  animate?: boolean;
}

export default function FormSection({
  number,
  title,
  description,
  children,
  infoBox,
  animate = true,
}: FormSectionProps) {
  return (
    <section
      className={`rounded-2xl p-6 md:p-8 mb-5 shadow-sm${animate ? ' section-enter' : ''}`}
      style={{ backgroundColor: 'var(--card)' }}
    >
      <div className="mb-6">
        <h2 className="font-display text-2xl font-semibold mb-1">
          {number}. {title}
        </h2>
        {description && (
          <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
            {description}
          </p>
        )}
      </div>

      {infoBox && (
        <div
          className="rounded-lg p-4 mb-6 text-sm leading-relaxed"
          style={{
            backgroundColor: 'var(--background)',
            borderLeft: '4px solid var(--primary)',
            color: 'var(--muted-foreground)',
          }}
        >
          {infoBox}
        </div>
      )}

      <div className="space-y-6">{children}</div>
    </section>
  );
}